<div class="new-quotation-component">
    <app-header
        [title]="('buyer.create-quotation.header.title' | translate)"
        (onGoBack)="voltar()"
    />
    <ng-scrollbar>
        <main class="new-quotation-wrapper">
            <quotation-type-component [isQuotationWithParts]="isQuotationWithParts" (onQuotationTypeChange)="onQuotationTypeChange($event)" (onImportFileClick)="quotationImportBudgetComponent.open()"/>
            <quotation-objective-component />

            <section class="quotation-content" [ngClass]="{ 'inverted': !isQuotationWithParts }">
                <quotation-vehicle-component [isQuotationWithParts]="isQuotationWithParts"/>
                <quotation-parts-component [isQuotationWithParts]="isQuotationWithParts" (onPartListChange)="handleFooterUpdate($event)" />
            </section>

            <quotation-other-infos-component />
        </main>
    </ng-scrollbar>
    <footer>
        <p><b>{{ partsQuantity }}</b> {{ 'Peças adicionadas' }}</p>
        <button customButton styleType="secondary" label="Solicitar cotação" iconName="check" [isLoading]="false" [isDisabled]="createQuotationIsDisabled || !alreadyLoadedERP" (click)="createQuotation()"></button>
    </footer>
</div>

<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
<app-import-budget (onOrcamentoFileUpload)="onQuotationFileUpload($event)" />
